import { render, staticRenderFns } from "./clientListener.vue?vue&type=template&id=2c83a368&scoped=true&"
import script from "./clientListener.vue?vue&type=script&lang=js&"
export * from "./clientListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83a368",
  null
  
)

export default component.exports